// extracted by mini-css-extract-plugin
var _1 = "ProPageLayout-module__body___wgsZl";
var _2 = "ProPageLayout-module__panel____hHIN";
var _3 = "ProPageLayout-module__topoBackground___Zo5Hx";
export { _1 as "body", _2 as "panel", _3 as "topoBackground" }
